import Background from 'formstone/jquery/background';
import Checkpoint from 'formstone/jquery/checkpoint';
import Cookie from 'formstone/jquery/cookie';
import Lightbox from 'formstone/jquery/lightbox';
import MediaQuery from 'formstone/jquery/mediaquery';
import Modal from 'formstone/jquery/modal';
import Navigation from 'formstone/jquery/navigation';
import Swap from 'formstone/jquery/swap';

window.Debounce = (callback, timeout) => {
  let timer = null;

  return (...args) => {
    window.clearTimeout(timer);

    timer = window.setTimeout(() => {
      callback(...args);
    }, timeout);
  };
};

window.SiteReady(($) => {
  console.log('Init: Main Site');

  let $window = $(window);
  let $body = $('body');


  // Tables

  $('.wp-block-table').find('table').wrap('<div class="table_wrapper"></div>');


  // Scroll

  let newScroll = -1;
  let lastScroll = 0;
  let newShift = -1;
  let lastShift = 100;

  function onScroll() {
    newScroll = $window.scrollTop();
    newShift = newScroll;
  }

  function onRAF() {
    if (newScroll != lastScroll) {
      let scrollDir = (newScroll < lastScroll) ? 'up' : 'down';

      if (newScroll > 0) {
        $body.addClass('scrolled');
      } else {
        $body.removeClass('scrolled');
      }

      lastScroll = newScroll;
    }

    window.requestAnimationFrame(onRAF);
  }

  $window.on('scroll', onScroll);
  window.requestAnimationFrame(onRAF);

  onScroll();

  // Mobile Nav

  $('.js-mobile_menu .current_page_item').parents('.nav_item').addClass('current-menu-ancestor');

  $('.js-mobile_menu .menu > .menu-item-has-children > a').each((index, el) => {
    let $link = $(el);
    let $handle = $link.children('span.toggle_handle');
    let active = ($link.parent('li').hasClass('current-menu-ancestor') || $link.parent('li').hasClass('current_page_item'));

    if (active) {
      $handle.addClass('fs-swap-active');
      $link.next('ul').addClass('fs-swap-active');
    }
  });

  $('.js-mobile_menu').on('navigation:open', function() {
    $('.js-mobile_menu').scrollTop(0);
  });


  // Filter Groups

  // $('.js-filter_group .js-filter_button').on('click', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $parent = $target.parents('.js-filter_group');
  //   let $buttons = $parent.find('.js-filter_button');
  //   // let $select = $parent.find('.js-filter_select');
  //   let $items = $parent.find('.js-filter_item');
  //   let active = $target.data('filter');

  //   $buttons.removeClass('active');
  //   $target.addClass('active');

  //   if (active == 'all') {
  //     $items.show();
  //   } else {
  //     $items.hide().filter('[data-filter="' + active + '"]').show();
  //   }
  // });

  // $('.js-filter_group .js-filter_select').on('change', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $parent = $target.parents('.js-filter_group');
  //   let $buttons = $parent.find('.js-filter_button');
  //   let active = $target.val();

  //   $buttons.filter('[data-filter="' + active + '"]').trigger('click');
  // });

  //

  $('.js-filter_form select').on('change', (e) => {
    let $target = $(e.currentTarget);
    let label = $target.find('option:selected').data('label');

    $target[0].dataset.selected = $target.val();
    $target.next('.js-filter_spacer').text(label);

    $target.parents('form').submit();
  });

  // Scroll Next

  $('.js-scroll_next').on('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    let $parent = $(e.currentTarget).parents('.js-scroll_next_parent');

    let height = $parent.outerHeight() - (window.scrollY - $parent[0].offsetTop);

    window.scrollDistance(height);
  });

  // Search Modal

  $('.js-search_modal').on('swap:activate', (e) => {
    let $target = $(e.currentTarget);

    setTimeout(() => {
      $target.find('input[type="text"]').first().focus();
    }, 50);
  });

  // Resize

  let onResize = window.Debounce(function() {
    let height = $(window).outerHeight();
    let width = $(window).outerWidth();


    if ( height > width ) {
      $('html').removeClass('is-landscape').addClass('is-portrait');
    } if ( width > height ) {
      $('html').removeClass('is-portrait').addClass('is-landscape');
    }
  });

  $(window).on('resize', () => {
    onResize();
  });

  onResize();

  // Plugins

  $('.js-navigation').navigation();
  $('.js-background').background();
  $('.js-swap').swap();
  $('.js-lightbox').lightbox();
  $('.js-modal').modal();
  // $('.js-tabs').tabs();

  $('.js-checkpoint, [data-checkpoint-animation]').checkpoint({
    offset: '100px',
    reverse: true
  });

  $('.has_ornament').checkpoint({
    offset: '30%',
    reverse: true
  });

  $('.js-icon').checkpoint({
    offset: '140px',
    reverse: true
  });

  // Forms

  $(document).on('gform_confirmation_loaded gform_page_loaded', function(e, form) {
    window.scrollToElement('#gf_' + form);
  });

  // Exit intent

  $('.js-modal[data-modal-options]').each((index, el) => {
    let $el = $(el);
    let data = $el.data('modal-options');

    let onload = $.cookie('get', data.id + '-onload');
    let onexit = $.cookie('get', data.id + '-exit');

    if (data.onLoad && !onload) {
      el.dispatchEvent(new CustomEvent('click'));

      $.cookie('set', data.id + '-onload', 'true', {
        path: '/',
        expires: (1000 * 60 * 60 * 24), // 24 hours
      });
    }

    if (data.exitIntent && !onexit) {
      $window.on('exitintent', (e) => {
        el.dispatchEvent(new CustomEvent('click'));

        $.cookie('set', data.id + '-exit', 'true', {
          path: '/',
          expires: (1000 * 60 * 60 * 24), // 24 hours
        });
      });
    }
  });


  //

  $('iframe[src*="youtube"]').each((index, el) => {
    let $el = $(el);

    if ($el.parents('.video_wrapper, .video_frame').length == 0) {
      $el.wrap('<div class="video_wrapper"></div>');
    }
  });

});